module.exports = __webpack_public_path__ + "img/开普云.d7d1289.d7d1289e.png";